import { Hero } from "@/components/sections/Hero";
import { VerticalSection } from "@/components/sections/VerticalSection";
import { HowItWorks } from "@/components/sections/HowItWorks";
import { WhySCC } from "@/components/sections/WhySCC";
import { TellUsSection } from "@/components/sections/TellUsSection";
import { VERTICALS } from "@/lib/content";
import SEO from "@/components/common/SEO";

export default function Home() {
  return (
    <div data-testid="home-page">
      <SEO
        title="Success Crest Consulting | Recruitment, HR & Business Solutions"
        description="Success Crest Consulting provides recruitment, HR consulting, career services, and AI-powered digital solutions for employers, professionals, and businesses."
        path="/"
      />

      <Hero />

      {VERTICALS.map((v) => (
        <VerticalSection
          key={v.id}
          vertical={v}
          tone={v.id === "career" ? "soft" : "white"}
        />
      ))}

      <HowItWorks />
      <WhySCC />
      <TellUsSection />
    </div>
  );
}
